import React, { Component } from "react";
import { Table, Button, Message, Label } from "semantic-ui-react";

class VehicleExpiryPrintReport extends Component {
  render() {
    
    const { transactions,total } = this.props;
    return (
        <Table celled fixed singleLine>
        <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan="6" style={{ textAlign:"center" }}>Vehicle Expiry Report</Table.HeaderCell>
        </Table.Row>

            <Table.Row>
                <Table.HeaderCell width={1} style={{ textAlign:'center' }}>Sr</Table.HeaderCell>
                <Table.HeaderCell width={6}>Name</Table.HeaderCell>
                <Table.HeaderCell width={6}>Company</Table.HeaderCell>
                <Table.HeaderCell width={4}>Mobile</Table.HeaderCell>
                <Table.HeaderCell width={2} style={{ textAlign:'center' }}>Plate#</Table.HeaderCell>
                <Table.HeaderCell width={3} style={{ textAlign:'center' }}>Expiry Date</Table.HeaderCell>
              </Table.Row>
        </Table.Header>

        <Table.Body>
          {transactions.map(transaction => (
            <Table.Row>
              <Table.Cell style={{ textAlign:'center' }}>{transaction.sr}</Table.Cell>
              <Table.Cell>{transaction.name}</Table.Cell>
              <Table.Cell style={{ whiteSpace: 'pre-line' }}>{transaction.company}</Table.Cell>
              <Table.Cell>{transaction.mobile}</Table.Cell>
              <Table.Cell style={{ textAlign:'center' }}>{transaction.plate}</Table.Cell>
              <Table.Cell style={{ textAlign:'center' }}>{transaction.expiry_date}</Table.Cell>
            </Table.Row>
            )
          )}

            {/* <Table.Row>
              <Table.Cell style={{ textAlign:"center" }}></Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell style={{ textAlign:"center" }}></Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell colspan="3" style={{ textAlign:"left",fontSize:'15px' }}><b>{total}</b></Table.Cell>
             
            </Table.Row> */}

        </Table.Body>
      </Table>
    );
  }
}
export default VehicleExpiryPrintReport;
